import "./dynamic-bundling-block.scss";